import { appClientConfig } from '@/utils/appClientConfig';

/**
 * The single place canonical `<link>` URLs are generated (A2P-4457). Always returns an absolute
 * URL (scheme + host): a path is resolved against `origin`, while an already absolute URL (e.g.
 * an editor-set cross-domain canonical from the CMS) is kept as-is. The fragment is dropped, as
 * it never identifies a different page.
 *
 * `origin` defaults to the configured site URL rather than `window.location`, so the server- and
 * client-rendered canonicals always match regardless of which host the request came in on.
 */
export const buildCanonicalUrl = (
  pathOrUrl: string,
  origin: string = appClientConfig.recruitWebUrl,
): string => {
  try {
    const url = new URL(pathOrUrl, origin);
    url.hash = '';
    return url.toString();
  } catch {
    // Missing/invalid origin config - better a relative canonical than a crashed page.
    return pathOrUrl;
  }
};
